import {createFileRoute, redirect} from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/campaign-reporting/$campaignId")({
  beforeLoad: ({params}) => {
    throw redirect({
      to: "/campaign/$campaignId",
      params: {campaignId: +params.campaignId},
      search: {tab: "reporting"},
      replace: true,
    });
  },
});
